export const LOGIN_REQUESTING = 'auth/LOGIN_REQUESTING';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LOGIN_FAILED = 'auth/LOGIN_FAILED';
